export default class DescriptiveLinks {
	static LINKS_SELECTOR = 'article[id^="post"] .post-meta > a';
	static NEW_ATTRIBUTE = 'aria-label';
	start() {
		$(DescriptiveLinks.LINKS_SELECTOR).each((i, element) => {
			$(element).attr(DescriptiveLinks.NEW_ATTRIBUTE, `Open  ${$(element).html()} posts`);
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/divi/controllers/descriptive-links.js